module.exports = __webpack_public_path__ + "assets/img/31.dd484bb2.png";